module.exports = __webpack_public_path__ + "resources/files/nibud_geldwijzer-fbe183d14f6a9c6520bcce3ceb4fe93a-cache.pdf";